import React, { useState, useRef, useEffect } from 'react';
import { PlayIcon, PauseIcon } from '@heroicons/react/24/solid';
import progressService from '../services/progress.service';

const VideoPlayer = ({ videoUrl, unitId, onComplete }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const videoRef = useRef(null);
  const progressBarRef = useRef(null);

  // Restore progress only after metadata is loaded and duration is finite
  useEffect(() => {
    setProgress(0);
    setDuration(0);
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
    }
  }, [unitId]);

  const handleTimeUpdate = () => {
    if (!videoRef.current) return;
    
    const progress = (videoRef.current.currentTime / videoRef.current.duration) * 100;
    setProgress(progress);
    progressService.save(unitId, progress);

    if (progress >= 95 && onComplete) {
      onComplete();
    }
  };

  const handleLoadedMetadata = () => {
    const dur = videoRef.current.duration;
    setDuration(dur);
    const savedProgress = progressService.get(unitId);
    if (
      savedProgress &&
      videoRef.current &&
      typeof dur === 'number' &&
      isFinite(dur) &&
      dur > 0
    ) {
      videoRef.current.currentTime = (savedProgress / 100) * dur;
    }
  };

  const togglePlay = () => {
    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  const handleProgressClick = (e) => {
    const rect = progressBarRef.current.getBoundingClientRect();
    const pos = (e.clientX - rect.left) / rect.width;
    videoRef.current.currentTime = pos * duration;
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className="relative bg-black rounded-lg overflow-hidden w-full aspect-video max-w-full" style={{maxWidth: 960}}>
      <video
        ref={videoRef}
        src={videoUrl}
        className="w-full h-full object-contain"
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
        controls
        controlsList="nodownload"
        style={{background: 'black'}}
      />
      {/* Custom controls can be added here if you want to extend further */}
    </div>
  );
};

export default VideoPlayer;